angular.module('picmonicng').directive('editorFact', [
  'EditorService',
  function (EditorService) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<li as-sortable-item="fact"><div as-sortable-item-handle><learn-fact fact="fact" player-service="EditorService"></learn-fact></div></li>',
    };
  },
]);
